export enum AttachmentType {
    HeroCard = "application/vnd.microsoft.card.hero",
    AdaptiveCard = "application/vnd.microsoft.card.adaptive",
    OrderTracking = "application/vnd.webstaurant.shipment.tracking",
    TaxTracking = "application/vnd.webstaurant.tax.tracking",
    ItemRefundReship = "application/vnd.webstaurant.item.refund-reship",
    ItemReturns = "application/vnd.webstaurant.item.returns",
    FoodQualityIssue = "application/vnd.webstaurant.item.food-quality-issue",
}
